import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import axios from "axios";
import { getCurrentInstance, ref } from "vue";
import LoginPage from "@/components/LoginPage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const instance = getCurrentInstance();
const API_URL = instance?.appContext.config.globalProperties.API_URL;

const shouldShowLoginPage = ref(true);

async function validateAuth(): Promise<boolean> {
  try {
    const res = await axios.get(`${API_URL}/auth/validate`, {
      withCredentials: true,
    });

    return !res.data.failed;
  } catch (error: any) {
    console.log("Couldn't validate");
    return false;
  }
}

async function loginPageLoader() {
  shouldShowLoginPage.value = !(await validateAuth());
  console.log(shouldShowLoginPage);
}

loginPageLoader();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_router_view),
    (shouldShowLoginPage.value)
      ? (_openBlock(), _createBlock(LoginPage, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})